var Schema = require('normalizr').Schema;
var arrayOf = require('normalizr').arrayOf

var surveySchema = new Schema('surveys', { idAttribute: 'id' });
var symptomSchema = new Schema('symptoms', { idAttribute: 'id' });
var contextSchema = new Schema('contexts', { idAttribute: 'id' });
var fieldSchema = new Schema('fields', { idAttribute: 'name' });
var sequenceSchema = new Schema('sequences', { idAttribute: 'field' });

surveySchema.define({
    symptom: symptomSchema,
    context: contextSchema,
    fields: arrayOf(fieldSchema),
    sequence: arrayOf(sequenceSchema)
});

module.exports = surveySchema;



// WEBPACK FOOTER //
// ./src/common/modules/survey/schemas.js